'use strict';

class AgenciesController {
  /* @ngInject */
  constructor(AgenciesService, $scope, $q) {
    Object.assign(this, {
      AgenciesService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getAgencies();

    this.onPagination = () => {
      this.getAgencies();
    };
  }

  getAgencies() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    let queryReady = this.AgenciesService.getModels(qOpts).then(agencies => {
      this.agencies = agencies;
    });
    let countReady = this.AgenciesService.getCount(qOpts).then(result => {
      this.agenciesCount = result.count;
    });
    this.promise = this.$q.all([queryReady, countReady]);
    return this.promise;
  }
}

export default AgenciesController;
